import { RowBox } from "components/common";
import { ChartSource, ChartType } from "constant/chart";
import { UpdateChartPanel } from "./single";
import { NetworkSelected } from "types/Network";
import { CreateMultipleUsage, CreateStatus, EventOnChange } from "../create/PSLWidget";

const UpdatePSLWidget = ({
    panel,
    onChange,
}: {
    panel: any;
    onChange?: Function;
}) => {
    const { chart } = panel;

    const mapChartData = (networks: NetworkSelected[]) => {
        return networks.map((network) => {
            const {
                gatewayId: gateway_id,
                ldsuUID,
                name,
                color,
                said,
                time_series
            } = network;
            return {
                gateway_id,
                device_id: ldsuUID,
                ldsuUID,
                name,
                color,
                said,
                time_series
            };
        });
    };

    const onWidgetChange: EventOnChange = (data) => {
        onChange?.({ ...data, data: mapChartData(data.data ?? []) });
    };

    const renderElement = () => {
        if (chart === ChartType.CARD_STATUS) {
            return <div className="px-2 py-2"> <CreateStatus panel={panel} onChange={(data) => onWidgetChange(data)} /> </div>
        } else if (chart === ChartType.BAR && panel.source === ChartSource.AGGREGATED_MULTIPLE_SENSORS) {
            return <div className="px-2 py-2"><CreateMultipleUsage panel={panel} onChange={(data) => onWidgetChange(data)} /> </div>
        }

        return <UpdateChartPanel />
    };

    return (
        <RowBox className="multiple-chart-block px-2 py-2 mb-3">
            {panel && renderElement()}
        </RowBox>
    );
};

export default UpdatePSLWidget;
